<app-header [showUserInfo]="false" [showHamburger]="false"></app-header>

<app-pan-card [isPageContainer]="true" header="404">
  <p>The requested page was not found.</p>
  <p>Please get in touch with your security provider.</p>
</app-pan-card>

<app-footer [public]="true" [copyright]="true"></app-footer>
